import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-24 border-t border-[#E8E2D9] bg-[#F5F2EB]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12 py-12 sm:py-16 grid sm:grid-cols-2 md:grid-cols-5 gap-8 sm:gap-10">
        <div className="md:col-span-2 sm:col-span-2">
          <img src="/ncontro-logo.png" alt="NContro" className="h-10 sm:h-12 w-auto" />
          <p className="text-sm text-[#5C5C5C] mt-4 max-w-md leading-relaxed">
            A curated marketplace connecting event planners with the world&apos;s finest caterers, restaurants, venues, florists and DJs.
          </p>
        </div>
        <div>
          <div className="eyebrow mb-4">Categories</div>
          <ul className="space-y-2 text-sm text-[#5C5C5C]">
            <li>Catering</li><li>Restaurants</li><li>Venues</li><li>Florists</li><li>DJs</li>
            <li>Rentals</li><li>A/V Services</li><li>Security</li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-4">Legal</div>
          <ul className="space-y-2 text-sm text-[#5C5C5C]">
            <li><Link to="/terms/planner" className="link-underline">Customer Terms of Service</Link></li>
            <li><Link to="/terms/vendor" className="link-underline">Vendor Agreement</Link></li>
            <li><Link to="/payment-policy" className="link-underline">Payment & Refund Policy</Link></li>
            <li><Link to="/privacy" className="link-underline">Privacy Policy</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-4">Company</div>
          <ul className="space-y-2 text-sm text-[#5C5C5C]">
            <li>About</li>
            <li>Journal</li>
            <li>For Vendors</li>
            <li>Contact</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E8E2D9]">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12 py-4 sm:py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-xs text-[#5C5C5C]">
          <div>© 2026 NContro Studio</div>
          <div className="tracking-[0.25em] uppercase">Crafted for tastemakers</div>
        </div>
      </div>
    </footer>
  );
}
